import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, LoadingController, ToastController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

import { PaymentMethodHandler } from '../../providers/payment-method-handler';
import { PaymentMethodListPage } from '../../pages/payment-method-list/payment-method-list';

import { ConsumerCheckoutHandler } from '../../providers/consumer-checkout-handler';
import { PurchaseHandlerProvider } from '../../providers/purchase-handler';

@Component({
  selector: 'page-consumer-checkout',
  templateUrl: 'consumer-checkout.html',
})
export class ConsumerCheckoutPage {
	offer: any;
	form : FormGroup;
	totalAmount: any;

	constructor(
		public navCtrl: NavController, 
		private formBuilder: FormBuilder,
		public navParams: NavParams,
		public paymentMethodHandler: PaymentMethodHandler,
		public consumerCheckoutHandler: ConsumerCheckoutHandler, public purchaseHandlerProvider: PurchaseHandlerProvider,
		public actionSheetCtrl: ActionSheetController,
		public loadingCtrl: LoadingController,
		public toastCtrl: ToastController
	) {
		this.offer = navParams.get('offer');	

	    this.form = this.formBuilder.group({
	    	"Id": [''],
	    	"OfferQty": [1, Validators.compose([
								Validators.required, Validators.min(1)
	    					])
		    			],	
	    	"CardNumber": [0, Validators.required]
	   	});  

	    this.setUpForm();

	   	this.totalAmount = this.offer.OfferPrice;	   

	   	console.log("Checkout finished");
	}

	ionViewWillEnter(){
		this.setUpForm();
	}	

	setUpForm(){
		var method = this.paymentMethodHandler.getDefaultMethod();

  		this.form.patchValue({
  			"CardNumber": method.id
  		});			
	}

	changedQty(){
		var qty = 1;

		if(this.form.value.OfferQty==""){
			qty = 1;
		}else{
			qty = parseInt(this.form.value.OfferQty);
		}

		this.totalAmount = this.offer.OfferPrice * qty;
	}

	addMethod(){
		this.navCtrl.push(PaymentMethodListPage);		
	}

	tryBuy(){
	   let actionSheet = this.actionSheetCtrl.create({
	     title: '$ ' + this.totalAmount + ' will be charged from your card. Are you sure?',
	     buttons: [
	       {
	         text: 'Yes',
	         handler: () => {
	           	console.log('Archive clicked');

	           	this.buyOffer()

	           	actionSheet.dismiss();

	           	return false;
	         }
	       },
	       {
	         text: 'No',
	         handler: () => {
	           actionSheet.dismiss();

	           return false;
	         }
	       }
	     ]
	   });

	   actionSheet.present();				
	}

	buyOffer(){
		var loader = this.loadingCtrl.create({
			content: "Working...",
			showBackdrop: true
		});

		loader.present();	

		var method = this.paymentMethodHandler.getMethodById(this.form.value.CardNumber);

		var data = {
			Quantity: this.form.value.OfferQty,
			ProductTypeId: 1,
			ProductId: this.offer.Id,
			Expiration: method.expiry,
			CVC: method.cvc,
			CardNumber: method.number,
			TotalAmount: this.totalAmount
		};

		this.consumerCheckoutHandler.buyOffer(data)
		.then((data: any)=>{
			loader.dismiss();

			if(data.Message){
				let toast = this.toastCtrl.create({
					message: 'There was an error: ' + data.Message,
					duration: 3000,
					position: 'bottom'
				});

				toast.present();	
			}else{
				let toast = this.toastCtrl.create({
					message: 'Purchased successfully!',
					duration: 5000,
					position: 'middle',
					showCloseButton: true,
					closeButtonText: 'Ok'
				});

				this.purchaseHandlerProvider.purchaseProduct({
					id: this.offer.Id
				});

				toast.onDidDismiss(() => {
					this.navCtrl.pop();
				});

				toast.present();	
			}
		})
		.catch((err)=>{
			loader.dismiss();

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-checkout/consumer-checkout.ts